import { render } from "./BeneficiaryStatusToggleButton.vue?vue&type=template&id=36337263"
import script from "./BeneficiaryStatusToggleButton.vue?vue&type=script&lang=js"
export * from "./BeneficiaryStatusToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__